import { LayoutPublic } from 'components/layout';
import { ButtonCTA, SpinnerSmall, TextField } from 'components/ui';
import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useSetNewPasswordMutation } from 'store/services/segmentsApi';
import { usePageTitle, useParseURLQueryParams } from 'utils';

export default function NewPassword() {
  usePageTitle('Set Password | Segments');
  const { query } = useParseURLQueryParams();
  const history = useHistory();

  const [setNewPassword, { isLoading }] = useSetNewPasswordMutation();

  const form = useRef(null);

  const passwordFieldRef = useRef(null);
  const confirmPasswordFieldRef = useRef(null);

  function validatePassword() {
    if (
      // @ts-ignore
      passwordFieldRef.current.value !== confirmPasswordFieldRef.current.value
    ) {
      // @ts-ignore
      confirmPasswordFieldRef.current.setCustomValidity(
        'Passwords do not match. Try again'
      );
    } else {
      // @ts-ignore
      confirmPasswordFieldRef.current.setCustomValidity('');
    }
  }

  useEffect(() => {
    const inputs = document.querySelectorAll('input');

    inputs.forEach((input) => {
      input.addEventListener(
        'invalid',
        () => {
          input.classList.add(
            'focus:ring-segments-at-risk',
            'focus:border-segments-at-risk'
          );
        },
        false
      );
      input.addEventListener('change', validatePassword);
    });
  }, []);

  /** @param {*} event */
  async function handleOnSubmit(event) {
    event.preventDefault();
    const { email, password } = event.target;

    // @ts-ignore
    if (!!!query.token) {
      toast.error('Failed to perform the action, you do not have a token', {
        onOpen: () => history.replace('/login'),
      });
      return;
    }
    const body = {
      email: email.value,
      new_password: password.value,
    };

    setNewPassword({ body, token: query.token }).finally(() =>
      history.replace('/login')
    );
  }

  return (
    <LayoutPublic>
      <main className="w-full max-w-screen-xl px-5 mx-auto my-10 lg:my-24">
        <div className="flex items-center ">
          <img
            src="/assets/logo-segments.png"
            alt="logo"
            className="w-8 h-8 md:w-10 md:h-10"
          />
          <h2 className="ml-3 text-2xl font-normal leading-7 tracking-segments_logo text-segments-dark">
            Segments
          </h2>
        </div>
        <form
          ref={form}
          onSubmit={handleOnSubmit}
          className="items-center justify-center max-w-sm mx-auto mt-14"
        >
          <div>
            <h3 className="text-2xl font-bold">Set a new password</h3>
            <label htmlFor="email" className="block text-sm font-bold mt-11">
              Email
            </label>
            <TextField
              // @ts-ignore
              name="email"
              type="email"
              placeholder="Required"
              required
            />
            <div className="mt-5">
              <label htmlFor="email" className="block text-sm font-bold">
                Password
              </label>
              <TextField
                ref={passwordFieldRef}
                // @ts-ignore
                name="password"
                type="password"
                minLength={5}
                maxLength={128}
                placeholder="Required"
                required
              />
              <label htmlFor="email" className="block mt-5 text-sm font-bold">
                Confirm Password
              </label>
              <TextField
                ref={confirmPasswordFieldRef}
                // @ts-ignore
                name="confirm_password"
                type="password"
                minLength={5}
                maxLength={128}
                placeholder="Required"
                required
              />
            </div>
          </div>
          <div className="flex items-center justify-between w-full mt-10">
            <ButtonCTA variant="main" type="submit" disabled={isLoading}>
              <span className="flex items-center justify-center w-full">
                {isLoading ? <SpinnerSmall /> : 'Set a new password'}
              </span>
            </ButtonCTA>
          </div>
        </form>
      </main>
    </LayoutPublic>
  );
}
